import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [RouterModule.forChild([        
        { path: '', data: { breadcrumb : '' }, loadChildren: () => import('./profissional-listar/profissional-listar.module').then(m => m.ProfissionalListarModule) },
        { path: 'inserir', data: { breadcrumb : 'Novo' }, loadChildren: () => import('./profissional-inserir/profissional-inserir.module').then(m => m.ProfissionalInserirModule) },
        { path: 'editar', data: { breadcrumb : 'Editar' }, loadChildren: () => import('./profissional-editar/profissional-editar.module').then(m => m.ProfissionalEditarModule) },
        { path: 'detalhar', data: { breadcrumb : 'Detalhar' }, loadChildren: () => import('./profissional-detalhar/profissional-detalhar.module').then(m => m.ProfissionalDetalharModule) }

    ])],
    exports: [RouterModule]
})
export class ProfissionalAppRoutingModule { }